import { render, staticRenderFns } from "./VoluntaryComplianceImportModal.vue?vue&type=template&id=7d12c284&scoped=true&"
import script from "./VoluntaryComplianceImportModal.vue?vue&type=script&lang=ts&"
export * from "./VoluntaryComplianceImportModal.vue?vue&type=script&lang=ts&"
import style0 from "./VoluntaryComplianceImportModal.vue?vue&type=style&index=0&id=7d12c284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12c284",
  null
  
)

export default component.exports